<template>
  <Flex
    :class="{
      'router-link-exact-active': isCurrentLocationCategory($route.query.locationCategory),
    }"
  >
    <Flex :class="{ 'cursor-pointer': true }">
      <router-link class="location-link" :to="getRoute(locationCategory)">
        {{ locationCategory.name }}
      </router-link>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'

export default {
  name: 'LocationCategorySelector',
  components: {
    Flex,
  },
  props: {
    locationCategory: Object,
  },
  methods: {
    getRoute(locationCategory) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
        },
      }
      route.query.location = locationCategory.attributePath
      return route
    },
    isCurrentLocationCategory(locationCategory) {
      return locationCategory === this.locationCategory.attributePath
    },
  },
}
</script>

<style lang="postcss" scoped>
.location-link {
  @apply break-words;
}
</style>
